import {NullableString} from "../../../types/nullable-types";

export enum PsoSeasonIntendedForEnum {
    Workers = "workers",
    Families = "families",
}

export interface IPsoMarketSeasonConfiguration {
    name: string;
    enabled: boolean;
    agent: string;
    startDate: NullableString;
    endDate: NullableString;
    intendedFor: PsoSeasonIntendedForEnum;
}

export interface IPsoClassesOfService {
    forResident: string[];
    forWorker: string[];
    forFamily: string[];
}

export interface IPsoMarketConfiguration {
    id: number;
    marketName: string;
    agent: string;
    useClassesOfService: boolean;
    allowNewBookings: boolean;
    bookDateStart: string;
    bookDateUntil: string;
    departureDateStart: string;
    departureDateUntil: string;
    routes: Array<string[]>;
    seasons?: IPsoMarketSeasonConfiguration[];
}



export interface IPsoMarketsConfiguration {
    markets: IPsoMarketConfiguration[];
    classesOfService: IPsoClassesOfService;
}



